export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 936
// module chunks = 0 1 2 3 4 5 6 7 8